let observerState = {};
const EVENT_TYPE = 'mousemove';
const INTERVAL_TIMEOUT = 200;

function detachMouseListener() {
    try {
        const { element, eventHandler } = observerState;
        element.removeEventListener(EVENT_TYPE, eventHandler);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log('Detach listener called, but no observer state is present');
    }
}

function stopPopupInterval() {
    clearInterval(observerState.timer);
}

const settingsPopupObserver = {
    observe({ appId, element, popupWindow, reactionCallback }) {
        detachMouseListener();
        stopPopupInterval();
        observerState = {
            appId,
            element,
            popupWindow,
            eventHandler: () => {
                detachMouseListener();
                // just in case someone closed popup and moved mouse over the modal quickly - we avoid double dispatch
                if (!popupWindow.closed) {
                    reactionCallback();
                }
            },
            timer: setInterval(() => {
                if (popupWindow.closed) {
                    stopPopupInterval();
                    detachMouseListener();
                    observerState.isModalOpen && reactionCallback();
                }
            }, INTERVAL_TIMEOUT),
            isModalOpen: true,
        };
        element.addEventListener(EVENT_TYPE, observerState.eventHandler);
    },
    // when modal closes - detach mouse listener as it no longer makes sense
    onAppSettingsClose() {
        detachMouseListener();
        observerState.isModalOpen = false;
    },
    // observing popupWindow still makes sense in case someone comes back to the modal, but only if they didn't switch to another app
    // we don't want to be too nice though, so if they switch to different app and come back and only then close the popup, this won't help them. too much of an edge case.
    onAppSettingsOpen(appId) {
        observerState.isModalOpen = true;
        if (appId !== observerState.appId) {
            stopPopupInterval();
        }
    },
};

export default settingsPopupObserver;
